( function ( $ ) {
	class LanguageSelector {

		/**
		 * Constructor.
		 *
		 * @return {void}
		 */
		constructor() {

			this.languageSelectorIcon = $( '.js-language-modal' );
			this.addEvents();

		}

		/**
		 * Add Events.
		 *
		 * @return {void}
		 */
		addEvents() {

			this.languageSelectorIcon.on( 'click', ( event ) => {
                $('.lang-modal').toggleClass('lang-modal--hidden');
			} );

		}

		
	}

	new LanguageSelector();

} )( jQuery );
